var _rect, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionBlueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 191,
    viewBox: "0 0 190 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.9,
    width: 144.318,
    height: 143.833,
    rx: 23,
    transform: "matrix(0.940174 0.340694 -0.34335 0.939207 54.3164 0)",
    fill: "url(#paint0_linear_15193_17749)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_15193_17749)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 45.874,
    width: 144.138,
    height: 144.138,
    rx: 23,
    fill: "url(#paint1_radial_15193_17749)",
    fillOpacity: 0.62
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_15193_17749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.8728 140.936C68.0323 140.936 66.5438 139.447 66.5438 137.607C66.5438 133.252 67.1614 129.491 68.3905 126.329C69.2922 123.945 70.756 121.542 72.7694 119.115C74.2517 117.349 76.9075 114.767 80.7492 111.382C84.5908 107.992 87.086 105.293 88.2409 103.279C89.3959 101.266 89.9641 99.0669 89.9641 96.6829C89.9641 92.3657 88.278 88.5796 84.9119 85.3124C81.5459 82.0452 77.414 80.4146 72.5224 80.4146C67.7976 80.4146 63.8509 81.8969 60.6887 84.8554C58.3788 87.017 56.6433 90.0681 55.4945 94.0086C54.7039 96.7138 52.0666 98.4431 49.2688 98.1096C45.7236 97.6896 43.389 94.1815 44.4019 90.7537C45.9583 85.4853 48.5647 81.2422 52.2149 78.0182C57.2856 73.5281 63.993 71.2861 72.3371 71.2861C81.1691 71.2861 88.2162 73.6887 93.4784 78.5C98.7406 83.3113 101.365 89.1231 101.365 95.9417C101.365 99.8883 100.439 103.526 98.5923 106.849C96.7456 110.178 93.1264 114.223 87.7468 118.991C84.1337 122.197 81.7682 124.562 80.6565 126.082C79.5448 127.601 78.7233 129.349 78.1922 131.319C77.7969 132.783 77.5252 134.932 77.3769 137.755C77.2843 139.534 75.8082 140.93 74.0294 140.93H69.8728V140.936ZM65.9262 156.87C65.9262 153.381 68.7549 150.552 72.2445 150.552C75.734 150.552 78.5628 153.381 78.5628 156.87C78.5628 160.36 75.734 163.189 72.2445 163.189C68.7549 163.189 65.9262 160.36 65.9262 156.87Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.3728 141.436H69.8728C67.7561 141.436 66.0438 139.723 66.0438 137.607C66.0438 133.208 66.6674 129.383 67.9236 126.15C68.8493 123.704 70.3451 121.254 72.3846 118.796L72.3864 118.794C73.8944 116.997 76.5742 114.394 80.4183 111.007C84.2563 107.62 86.6964 104.967 87.8072 103.03C88.9169 101.096 89.4641 98.9835 89.4641 96.6829C89.4641 92.5138 87.8424 88.8536 84.5637 85.6712C81.2955 82.4989 77.2905 80.9146 72.5224 80.9146C67.912 80.9146 64.0912 82.3568 61.0303 85.2204C58.8023 87.3055 57.1053 90.2697 55.9745 94.1485L55.9744 94.1488C55.1148 97.0901 52.2485 98.9681 49.21 98.6061C45.3598 98.15 42.821 94.3395 43.9224 90.612C45.502 85.2652 48.1547 80.9374 51.8836 77.6437C57.0658 73.055 63.9007 70.7861 72.3371 70.7861C81.2627 70.7861 88.4407 73.2164 93.8158 78.131C99.1764 83.0323 101.865 88.9759 101.865 95.9417C101.865 99.97 100.919 103.692 99.0296 107.092C97.1407 110.497 93.4693 114.588 88.0785 119.366C84.4634 122.573 82.1362 124.906 81.06 126.377C79.9877 127.843 79.1915 129.533 78.675 131.449L78.6749 131.45C78.2936 132.862 78.0239 134.969 77.8762 137.781L70.3728 141.436ZM70.3728 141.436V141.43M70.3728 141.436V141.43M70.3728 141.43H74.0294C76.0733 141.43 77.7696 139.826 77.8762 137.781L70.3728 141.43ZM72.2445 150.052C68.4787 150.052 65.4262 153.105 65.4262 156.87C65.4262 160.636 68.4787 163.689 72.2445 163.689C76.0102 163.689 79.0628 160.636 79.0628 156.87C79.0628 153.105 76.0102 150.052 72.2445 150.052Z",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_15193_17749",
    x: -3,
    y: 42.874,
    width: 150.137,
    height: 150.138,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_15193_17749"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_15193_17749",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_15193_17749",
    x: 43.1641,
    y: 70.2861,
    width: 68.6211,
    height: 103.321,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4.709,
    dy: 4.709
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.3545
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_15193_17749"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_15193_17749",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15193_17749",
    x1: 30.1784,
    y1: 36.5242,
    x2: 177.064,
    y2: 93.3333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353A6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2E4C97"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_15193_17749",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(72.0689 117.943) rotate(90) scale(79.2758)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93A1ED",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#93A1ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionBlueIcon);
export default __webpack_public_path__ + "static/media/question-blue-icon.3e261bc9e0a9617943a960afd165bed3.svg";
export { ForwardRef as ReactComponent };